import React from 'react';

function Maldives(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_124047)">
        <mask
          id="mask0_800_124047"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_124047)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0H36V22C36 23.1046 35.1046 24 34 24H2C0.895431 24 0 23.1046 0 22V0Z"
            fill="#C51918"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0H36V24H0V0Z"
            fill="#C51918"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.75 6H29.25V18H6.75V6Z"
            fill="#579D20"
          />
          <path
            d="M7.75 7H28.25V17H7.75V7Z"
            stroke="#B6EB9A"
            strokeOpacity="0.238111"
            strokeWidth="2"
          />
          <mask
            id="mask1_800_124047"
               style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="6"
            y="6"
            width="24"
            height="12"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M6.75 6H29.25V18H6.75V6Z"
              fill="white"
            />
            <path d="M7.75 7H28.25V17H7.75V7Z" stroke="white" strokeWidth="2" />
          </mask>
          <g mask="url(#mask1_800_124047)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M18.0372 12.4625C18.018 15.5282 20.7332 17.1627 20.7332 17.1627C17.635 17.4861 15.5737 14.9895 15.5737 12.4924C15.5737 9.99524 18.3835 7.9325 20.7332 7.00105C20.7332 7.00105 18.0563 9.39679 18.0372 12.4625Z"
              fill="#F9FAFA"
            />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_124047">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Maldives;
